<template lang='pug'>
  .modal-popup
    .modal.fade(:id='modalId' aria-hidden='true', role='dialog', tabindex='-1')
      .modal-dialog(role='document' :class='isAuthFraudCheckOtpStep ? "verify-otp-modal": ""')
        slot
</template>

<script>
import { authenticationSteps } from '@/modules/config/authentication'
import { mapState } from 'vuex'

export default {
  props: {
    modalId: {
      type: String,
      default: 'default-popup'
    }
  },

  computed: {
    ...mapState({
      authStep: state => state.authentication.authStep
    }),

    isAuthFraudCheckOtpStep () {
      return this.authStep === authenticationSteps.AUTH_FRAUD_CHECK_OTP
    }
  }
}
</script>

<style lang='scss' scoped>
  .verify-otp-modal {
    max-width: 600px !important;
  }
</style>
